export const testAttributes = {
    MORTGAGE_RATES_ERROR_CONTAINER: 'MORTGAGE_RATES_ERROR_CONTAINER'
}